import {
  JsonApiQueryParameters,
  formatQueryForJsonApi,
  transformResponseFromJsonApi,
} from '@evolve/common-ui';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from 'evolve-ui';

export type IActivity = {
  id: string;
  name: string;
};

// Define a service using a base URL and expected endpoints
export const activitiesApi = createApi({
  reducerPath: 'activities',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.GATSBY_COMMUNICATIONS_API_URL}/activity-sectors`,
    mode: 'cors',
    prepareHeaders,
  }),
  tagTypes: ['Activity'],
  endpoints: (builder) => ({
    getActivities: builder.query<
      { values: IActivity[] },
      JsonApiQueryParameters
    >({
      providesTags: ['Activity'],
      query: formatQueryForJsonApi,
      transformResponse: transformResponseFromJsonApi<IActivity>,
    }),
  }),
});

export const { useGetActivitiesQuery } = activitiesApi;
